import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import GlobalStyles from './GlobalStyles';
import useSmoothScroll from '../../hooks/useSmoothScroll';

/**
 * Layout component that wraps all pages
 * Includes header and footer components and smooth scrolling functionality
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render within the layout
 */
const Layout = ({ children }) => {
  // Initialize smooth scrolling
  const { lenis, isReady } = useSmoothScroll({
    enableReveal: true,
    enableParallax: true
  });

  // Scroll to top on page load
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    }
  }, [lenis]);

  return (
    <div className="flex flex-col min-h-screen">
      <GlobalStyles />
      <Header />
      <main className="flex-grow pt-24">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
